import Controller from '../abstracts/Controller';
import 'scss-templates/t-listing.scss';

export default class ListingController extends Controller {
  static get COMPONENTS() {
    return [
      'FiltersComponent',
      'GridModeComponent',
      'PriceRangeComponent',
      'ShortcutComponent',
      'ListingHeadComponent',
      'LookbookComponent',
      'CategoryFilterComponent',
      'SearchComponent',
      'PaginationComponent',
      'CarouselComponent',
      'RecommendationEngineComponent',
      'ListingEditorialComponent',
      'WishlistComponent',
      'VisualMerchandisingComponent',
      'HistoryManagerComponent',
      'SaleRangeComponent',
      'JournalComponent',
      'InfiniteScrollTextComponent',
      'SocialComponent'
    ];
  }
}
